var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38975 31.8334L10.071 19.8001L0.333496 12.8334H12.3668L16.1668 0.166748L19.9668 12.8334H32.0002L22.2627 19.8001L25.9439 31.8334L16.1668 24.3918L6.38975 31.8334Z",
    fill: "url(#paint0_radial_19_1517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_19_1517",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1627 16.011) scale(19.7443 19.7628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1583,
    stopColor: "#FFFA2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2883,
    stopColor: "#FFF128"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4964,
    stopColor: "#FFDA24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7549,
    stopColor: "#FFB41D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.591465ce73701820c8b4964396e590ce.svg";
export { ForwardRef as ReactComponent };